import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Calendar, CheckSquare, Scissors, Phone, Type } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function IncludesSection() {
  const items = [{
    icon: FileText,
    text: 'El PDF completo (Plan de 14 días)'
  }, {
    icon: FileText,
    text: 'Plantilla “Mapa de realidad”'
  }, {
    icon: Calendar,
    text: 'Calendario de pagos'
  }, {
    icon: CheckSquare,
    text: 'Checklist de fugas'
  }, {
    icon: Scissors,
    text: 'Sobres imprimibles'
  }, {
    icon: Type,
    text: 'Versión recomendada en letra grande'
  }, {
    icon: Phone,
    text: 'Guiones de llamadas para pedir reducción'
  }];
  return <section className="bg-white py-20 px-4" data-id="element-111">
      <div className="max-w-3xl mx-auto" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-113">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-12 text-center" data-id="element-114">
            Qué incluye exactamente
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-115">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.05
          }} viewport={{
            once: true
          }} className="flex items-center gap-4 p-4 rounded-lg bg-[#FAF7F2] border border-[#e5e0d8]" data-id="element-116">
                <div className="bg-[#1B2A4A] p-3 rounded-full text-white" data-id="element-117">
                  <item.icon className="w-6 h-6" data-id="element-118" />
                </div>
                <span className="text-lg text-[#2D2A26] font-medium" data-id="element-119">
                  {item.text}
                </span>
              </motion.div>)}
          </div>

          <div className="text-center" data-id="element-120">
            <CTAButton data-id="element-121">QUIERO MI PLAN AHORA</CTAButton>
          </div>
        </motion.div>
      </div>
    </section>;
}